/**
 * Available betslip mode types used in betslip
 */
export const BETSLIP_TYPES = {
  COMBI: 1,
  SINGLE: 2,
  SYSTEM: 3,
};
/**
 * Betslip type names
 * @type {{COMBI: string, SINGLE: string, SYSTEM: string}}
 */
export const BETSLIP_TYPE_NAMES = {
  COMBI: 'Mobile.combiBetslip',
  SINGLE: 'Mobile.Single',
  SYSTEM: 'Mobile.systemBetslip'
};
/**
 * Betslip game mode
 * We need to check each game what type is it and properly set BetMode property
 */
export const BETSLIP_GAME_MODES = {
  PRE_LIVE: 0,
  LIVE: 1,
  VFL: 2,
  VHC: 3,
  VDR: 4,
  JACKPOT: 5,
  MIXED: 6,
  FREEBET: 7,
};
/**
 * Platforms on which app is running
 * @type {{WEB: number, MOBILE: number, ONLINE_SHOP: number}}
 */
export const PLATFORMS = {
  WEB: 0,
  MOBILE: 1,
  ONLINE_SHOP: 2,
};

/**
 * Betslip Item Types
 */
export const ITEM_TYPES = {
  PRE_MATCH: 1,
  LIVE: 2,
  VIRTUAL_FOOTBALL: 3,
  VIRTUAL_HORSE: 4,
  VIRTUAL_DOGS: 5,
  PLAYER: 6,
  OUTRIGHT: 7,
  VIRTUAL_TENNIS: 8,
  VIRTUAL_BASKETBALL: 9,
  BET_BUILDER: 10,
  BOOSTED_ODDS: 11,
};

export const BETSLIP_STATUS = {
  PLACED: 0,
  WON: 1,
  LOST: 2,
  PENDING: 4,
  PAID: 7,
  VOID: 9,
  CACHEDOUT: 12,
  REJECTED: 5,
  JACKPOTWON: 13,
  JACKPOTLOST: 14,
  CANCELLED: 3,
  HALFWON: 10,
  HALFLOST: 11,
  CASHBACK: 15,
};
/**
 * Betslip settings keys explained
 */
export const BETSLIP_SETTINGS = {
  MIN_BET_AMOUNT: 1,
  MAX_BET_AMOUNT: 2,
  DEFAULT_CURRENCY: 35,
  MAX_GAMES_COUNT: 53,
  MULTIPLE_SAME_MATCH_MARKETS: 65,
  USE_RESERVATION_CODE: 114,
  MAX_COMBS: 149,
  MAX_OUTCOMES_COUNT: 150,
  USE_FREEBET: 154,
  SCORECAST_ENABLED: 164,
  USE_CASHOUT: 166,
  MIN_LINE_AMOUNT: 177,
  MAX_LINE_AMOUNT: 178,
  CANCEL_BS_PERIOD: 104,
  BS_PAYOUT_TIMEOUT: 105,
  CAN_VIEW_LIVE_STREAM_WITHOUT_BALANCE: 192,
  BET_BUILDER_MARKET_ID: 208,
  BET_BUILDER_OUTCOME_ID: 209,
  BET_BUILDER_API_KEY: 210,
  SPORTCAST_API_URL: 217,
};
/**
 * Local storage key for betslip
 * @type {string}
 */
export const BETSLIP_STORAGE_KEY = 'betslip_desktop';
/**
 * status codes used in betslip placement messages
 */
export const BETSLIP_MSG_STATUS = {
  ERROR: -1,
  PLACED: 0,
  INVALID_USER: 1,
  PENDING: 4,
  REJECTED: 5,
  NO_FUNDS: 41,
  TAKE_ACTION: -999,
};

export const CAN_VIEW_LIVE_STREAM = 192;
